var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page---2.2.2-(Bank-Offers)-Copy",
    transform: "translate(-1061.000000, -609.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_close_1609004_000000",
    transform: "translate(1061.000000, 609.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5873233,13 L25.8507358,22.2634126 C26.7164214,23.1290981 26.7164214,24.485108 25.8507358,25.3507358 C24.9850503,26.2163637 23.6290404,26.2164214 22.7634126,25.3507358 L13.5,16.0873233 L4.23658742,25.3507358 C3.37090187,26.2164214 2.01489201,26.2164214 1.14926417,25.3507358 C0.283636323,24.4850503 0.283578611,23.1290404 1.14926417,22.2634126 L10.4126767,13 L1.14926417,3.73658742 C0.283578611,2.87090187 0.283578611,1.51489201 1.14926417,0.649264167 C2.01494972,-0.216363677 3.37095958,-0.216421389 4.23658742,0.649264167 L13.5,9.91267674 L22.7634126,0.649264167 C23.6290981,-0.216421389 24.985108,-0.216421389 25.8507358,0.649264167 C26.7163637,1.51494972 26.7164214,2.87095958 25.8507358,3.73658742 L16.5873233,13 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0dfa4b858ef41d5607c23112abdb3946.svg";
export { ForwardRef as ReactComponent };